import './LoadingIndicator.css';
//#region src/LoadingIndicator/LoadingIndicator.module.css
var LoadingIndicator_module_default = {
	"loading": "pur4kG_loading",
	"loadingIndicatorSpin": "pur4kG_loadingIndicatorSpin"
};
//#endregion
export { LoadingIndicator_module_default as default };

//# sourceMappingURL=LoadingIndicator.module.js.map